import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app'
import { createQueryClient } from './lib/query-client'
import { runtimeConfigQuery } from './lib/runtime-config'
import { initTelemetry, reportError } from './lib/telemetry'
import './index.css'

const queryClient = createQueryClient()
queryClient.fetchQuery(runtimeConfigQuery).then(initTelemetry, () => undefined)

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('#root not found')
}

createRoot(rootElement, { onRecoverableError: (error) => reportError(error) }).render(
  <StrictMode>
    <App queryClient={queryClient} />
  </StrictMode>,
)
